'use strict';

var floor = require('./floor');

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function DayFromYear(y) {
	return (365 * (y - 1970)) + floor((y - 1969) / 4) - floor((y - 1901) / 100) + floor((y - 1601) / 400);
};




//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/DayFromYear.js
// module id = 338
// module chunks = 0